import Config from "config";
import axios from "axios";

const backendPFSURL = Config?.backendPFSURL;
const API_URL = process.env.API_ROOT_URL + backendPFSURL;
const searchPagePath = Config?.pagesLink?.search;
const $ = window.$;

const mapipingForFriendlyUrl = {
  "Tab=popularProperty": "/th/propertyforsale/search/popular-propert",
  "Tab=newProperty": "/th/propertyforsale/search/new-property",
  "Tab=promoProperty": "/th/propertyforsale/search/promotion",
  "propertyType=01": "/th/propertyforsale/search/land",
  "propertyType=02": "/th/propertyforsale/search/house",
  "propertyType=03": "/th/propertyforsale/search/townhouse",
  "propertyType=05": "/th/propertyforsale/search/condominium",
  "propertyType=04": "/th/propertyforsale/search/commercial-building",
  "propertyType=12": "/th/propertyforsale/search/warehouse",
  "propertyType=09": "/th/propertyforsale/search/factory",
  "propertyType=15": "/th/propertyforsale/search/apartment",
  "propertyType=10": "/th/propertyforsale/search/office-building",
  "propertyType=20": "/th/propertyforsale/search/resort",
  "province=10": "/th/propertyforsale/search/bangkok",
  "province=12": "/th/propertyforsale/search/nonthaburi",
  "province=13": "/th/propertyforsale/search/pathumthani",
  "province=11": "/th/propertyforsale/search/samutprakan",
  "province=73": "/th/propertyforsale/search/nakhonpathom",
  "province=50": "/th/propertyforsale/search/chiangmai",
  "province=20": "/th/propertyforsale/search/chonburi",
  "province=40": "/th/propertyforsale/search/khonkaen",
  "province=30": "/th/propertyforsale/search/nakhonratchasima",
  "province=83": "/th/propertyforsale/search/phuket",
  "rangePrice=0,1000000": "/th/propertyforsale/search/price-0-1m",
  "rangePrice=1000000,3000000": "/th/propertyforsale/search/price-1-3m",
  "rangePrice=3000000,5000000": "/th/propertyforsale/search/price-3-5m",
  "rangePrice=5000000,10000000": "/th/propertyforsale/search/price-5-10m",
  "rangePrice=10000000,20000000": "/th/propertyforsale/search/price-10-20m",
  "rangePrice=20000000": "/th/propertyforsale/search/price-over20m",
};

export const gotoSearchPage = (args) => {
  // Province
  // District
  // SubDistrict
  // PropertyType
  // RangePrice
  // AreaRange
  // UseableAreaRange
  // Bedroom
  //bathroom
  // Station
  // Keyword
  // AssetTypes

  if (Object.keys(args).length === 0) {
    return searchPagePath;
  }

  let queryParams = [];
  Object.keys(args).forEach(function (key) {
    var field = args[key].fieldName;
    if (args[key].value) {
      if (key === "rangePrice" || key === "areaRange" || key === "useableAreaRange") {
        let value = args[key].value;
        let from = "0";
        let to = "0";

        if (value.indexOf("สูงสุด") !== -1) {
          to = value;
          value = `${unitToValue(from)},${unitToValue(to)}`;
        } else if (value.indexOf("เริ่มต้น") !== -1) {
          from = value;
          to = args[key].values.slice(-1)[0];
          value = `${unitToValue(from)}`;
        } else {
          from = value.split("-")[0];
          to = value.split("-")[1];
          value = `${unitToValue(from)},${unitToValue(to)}`;
        }

        // value = `${unitToValue(from)},${unitToValue(to)}`;
        queryParams.push(`${field}=${value}`);
      } else if (key === "order") {
      } else if (key === "station") {
        queryParams.push(`${field}=${args[key].value}`);
        var location = args[key].option.filter((x) => x.value == args[key].value)[0];
        if (location) {
          queryParams.push(`Nearby=${JSON.stringify(location.location)}`);
        }
      } else {
        queryParams.push(`${field}=${args[key].value}`);
      }
    } else if (typeof args[key] === "string" && args[key]) {
      queryParams.push(`${field}=${args[key]}`);
    }
  });
  if (mapipingForFriendlyUrl[queryParams.join("&")]) {
    return mapipingForFriendlyUrl[queryParams.join("&")] + "?";
  }
  return searchPagePath + "?" + queryParams.join("&") + "&" + getUTM();
};

export function unitToValue(num) {
  const multiple = num.indexOf("บาท") !== -1 ? 1000000 : num.indexOf("ไร่") !== -1 ? 400 : 1;
  const value = parseFloat(num.replace(/\D+/g, ""));
  // console.log("float", num, value)
  return value * multiple;
}

export function addSearchUrlParameter(obj, property) {
  if (history.pushState) {
    let param = [];

    const paramKeys = Object.keys(obj);
    const paramValues = Object.values(obj);

    for (const i in paramKeys) {
      param = [...param, `${paramKeys[i]}=${paramValues[i] ?? ""}`];
    }

    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      gotoSearchPage(property.searchFilter) +
      (param.length > 0 && `${param.join("&")}`);
    window.history.pushState({ path: newurl }, "", newurl);
  }
}

export function addCommas(nStr, z) {
  nStr += "";
  nStr = nStr.replace(/,/g, "");
  let x = nStr.split(".");
  let x1 = x[0];
  let x2 = x.length > 1 ? "." + x[1] : "";
  let rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  if (z !== undefined) {
    if (z === 0) {
      x2 = "";
    } else {
      x2 = isNaN(parseFloat(x2)) ? "." + "0".repeat(z) : parseFloat(x2).toFixed(z).slice(1);
    }
  }
  return x1 + x2;
}

export function getUTM() {
  let utmParam = "";
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"].forEach((x) => {
    var temp = getURLParameter(x);
    if (temp) {
      utmParam += "&" + x + "=" + temp;
    }
  });
  return utmParam.length > 1 ? utmParam.slice(1) : utmParam;
}

export function getURLParameter(name) {
  name = name.toLowerCase();
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.search.toLowerCase()
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

export function getPropertyType(property) {
  var propertyType = (property.PropertyTypeName ?? "")
    .trim()
    .replace(/ +(?= )/g, "")
    .split(" ")[1];

  if (propertyType === "บ้านพักอาศัย") {
    return "บ้านเดี่ยว";
  } else if (propertyType === "ห้องชุดพักอาศัย") {
    return "คอนโดมิเนียม";
  } else if (propertyType === "ที่ดินว่างเปล่า") {
    return "ที่ดิน";
  } else if (propertyType === "อาคารโรงงาน") {
    return "โรงงาน";
  } else {
    return propertyType;
  }
}

export function getPropertyTypeEn(property) {
  var propertyType = (property.PropertyTypeName ?? "")
    .trim()
    .replace(/ +(?= )/g, "")
    .split(" ")[0];

  switch (propertyType) {
    case "15":
      return "apartment"; 
    case "05":
      return "condo"; 
    case "02":
      return "house"; 
    case "01":
      return "land"; 
    case "99":
      return "manufactured"; 
    case "03":
      return "townhouse";
    default:
      return "other";
  }
}

export function getArea(property) {
  var typeCode;

  if (hasValue(property.PropertyTypeName)) {
    typeCode = property.PropertyTypeName.trim().split(" ")[0];
  } else {
    typeCode = null;
  }

  if (typeCode === "05") {
    //condo
    if (hasValue(property.UseableArea) && property.UseableArea !== 0) {
      return {
        value: property.UseableArea.toFixed(2),
        unit: "ตร.ม.",
      };
    } else if (hasValue(property.AreaValue) && property.AreaValue !== 0) {
      return {
        value: property.AreaValue.toFixed(2),
        unit: "ตร.ม.",
      };
    } else {
      return null;
    }
  } else if (typeCode === "17") {
    //Office suite
    if (hasValue(property.UseableArea) && property.UseableArea !== 0) {
      return {
        value: property.UseableArea.toFixed(2),
        unit: "ตร.ม.",
      };
    } else if (hasValue(property.AreaValue) && property.AreaValue !== 0) {
      return {
        value: property.AreaValue.toFixed(2),
        unit: "ตร.ม.",
      };
    } else {
      return null;
    }
  } else if (typeCode === "02" || typeCode === "03" || typeCode === "04" || typeCode === "15") {
    // House , Townhouse , Commercial building , Apartment
    if (hasValue(property.AreaValue) && property.AreaValue !== 0) {
      return {
        value: property.AreaValue.toFixed(2),
        unit: "ตร.ว.",
      };
    } else {
      return null;
    }
  } else if (typeCode === "99") {
    // Machine
    return null;
  } else {
    //other
    if (hasValue(property.Area) && property.Area !== "0-0-0.00") {
      return {
        value: property.Area,
        unit: "ไร่",
      };
    } else if (hasValue(property.Rai) && hasValue(property.Ngan) && hasValue(property.SquareArea)) {
      const formattedString = `${property.Rai}-${property.Ngan}-${
        property.SquareArea.toFixed(2) || "0.00"
      }`;
      if (formattedString == "0-0-0.00") {
        return null;
      }
      return {
        value: formattedString,
        unit: "ไร่",
      };
    } else {
      return null;
    }
  }
}

export function showBedAndBath(property) {
  var typeCode;

  if (hasValue(property.PropertyTypeName)) {
    typeCode = property.PropertyTypeName.trim().split(" ")[0];
  } else {
    typeCode = null;
  }

  if (
    typeCode === "02" ||
    typeCode === "03" ||
    typeCode === "04" ||
    typeCode === "15" ||
    typeCode === "05" ||
    typeCode === "20" ||
    typeCode === "08"
  ) {
    //show bedroom and bathroom icon
    return true;
  } else {
    //other
    return false;
  }
}

export function showAreaValue(property) {
  var typeCode;

  if (hasValue(property.PropertyTypeName)) {
    typeCode = property.PropertyTypeName.trim().split(" ")[0];
  } else {
    typeCode = null;
  }

  if (typeCode === "05" || typeCode === "17") {
    //not show Area icon
    return false;
  } else {
    //other
    return true;
  }
}

export function showUseableAreaValue(property) {
  const showUseableArea = ["02", "03", "04", "15", "05", "17"];
  var typeCode;

  if (hasValue(property.PropertyTypeName)) {
    typeCode = property.PropertyTypeName.trim().split(" ")[0];
  } else {
    typeCode = null;
  }

  if (showUseableArea.indexOf(typeCode) !== -1) {
    //show UseableArea icon
    return true;
  } else {
    //other
    return false;
  }
}

function hasValue(val) {
  if (val === null || val === "" || val === undefined) {
    return false;
  }

  return true;
}

export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const postApiDataAsync = async (args) => {
  let objRequest = args.objRequest;
  console.log("in async (post) ", args.urlPath, objRequest);

  let apiUrl = API_URL;

  if (args.apiUrl) {
    apiUrl = process.env.API_ROOT_URL + args.apiUrl;
  }

  return axios.post(`${apiUrl}${args.urlPath}`, args.objRequest).then(
    function (data) {
      const result = JSON.parse(data.data.d);
      if (result.Success) {
        return result.Data;
      }
      throw result;
    },
    function (error) {
      throw {
        success: false,
        errorMsg: "ไม่สามารถดำเนินการได้ในขณะนี้ โปรดลองใหม่ในภายหลัง",
        errorCode: error.response ? error.response.status : error,
      };
    }
  );
};

export const getApiDataAsync = async (args) => {
  console.log("in async (get) ", args.urlPath, args.params);

  let apiUrl = API_URL;

  if (args.apiUrl) {
    apiUrl = process.env.API_ROOT_URL + args.apiUrl;
  }

  return await axios
    .get(`${apiUrl}${args.urlPath}`, {
      params: args.params,
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      data: { unused: 0 },
    })
    .then(
      function (data) {
        const result = JSON.parse(data.data.d);
        if (result.Success) {
          return result.Data;
        }
        throw result;
      },
      function (error) {
        throw {
          success: false,
          errorMsg: "ไม่สามารถดำเนินการได้ในขณะนี้ โปรดลองใหม่ในภายหลัง",
          errorCode: error.response ? error.response.status : error,
        };
      }
    );
};

export const tempgetApiDataAsync = async (args) => {
  return await axios
    .get("\\SiteCollectionDocuments\\assets\\PFS2022\\constants.json", {
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      data: { unused: 0 },
    })
    .then(
      function (data) {
        const result = data.data.d;
        if (result.Success) {
          return result.Data;
        }
        throw result;
      },
      function (error) {
        throw {
          success: false,
          errorMsg: "ไม่สามารถดำเนินการได้ในขณะนี้ โปรดลองใหม่ในภายหลัง",
          errorCode: error.response ? error.response.status : error,
        };
      }
    );
};

export function kloader(value) {
  const loader = $("#loadFormDiv");

  if (typeof value !== "undefined") {
    if (value) {
      console.log("kloader start");
      loader.removeClass("hide");
    } else {
      console.log("kloader stop");
      $(loader).addClass("hide");
    }
  } else {
    if (loader.hasClass("hide")) {
      console.log("kloader start");
      loader.removeClass("hide");
    } else {
      console.log("kloader stop");
      $(loader).addClass("hide");
    }
  }
}

export function valueRangeMaxMin(fieldName, from, to) {
  let value = "";
  if (from === "ไม่ระบุ" && to === "ไม่ระบุ") {
    value = "";
  } else if (from === "ไม่ระบุ" || from === "") {
    value = "สูงสุด " + to;
  } else if (to === "ไม่ระบุ" || to === "") {
    value = "เริ่มต้น " + from;
    to = "MAX";
  } else {
    value = `${from} - ${to}`;
  }

  return { fieldName, value, from, to };
}

export function copyObject(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export function getPathFromUrl(url) {
  var questionMarkIndex = url.indexOf("?");
  var sharpIndex = url.indexOf("#");

  if (questionMarkIndex === -1 && sharpIndex === -1) {
    return url;
  }

  var endIndex = url.length;

  if (questionMarkIndex !== -1 && questionMarkIndex < endIndex) {
    endIndex = questionMarkIndex;
  }

  if (sharpIndex !== -1 && sharpIndex < endIndex) {
    endIndex = sharpIndex;
  }

  return url.slice(0, endIndex);
}

export function areEqualObjValue(a, b) {
  var valid = true;
  Object.keys(a).forEach((key, index) => {
    if (!a[key] || !b[key]) {
      return;
    }
    if (a[key].value !== b[key].value) {
      valid = false;
      return;
    }
    if (a[key].option?.length !== b[key].option?.length) {
      valid = false;
      return;
    }
  });
  return valid;
}

export function noSpecialChar(value) {
  const noSpecialRegEx = /[^A-Za-z0-9\u0E01-\u0E3A\u0E40-\u0E4D\-\s]/g;
  return value.replace(noSpecialRegEx, "");
}

export function scrollToValue(value) {
  document.body.scrollTop = value; // For Safari
  document.documentElement.scrollTop = value; // For Chrome, Firefox, IE and Opera
}

export function setCookie(cname, cvalue, exdays) {
  console.log("react setCookie" + cvalue);
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function containThai(value) {
  const isThai = /([\u0E00-\u0E7F]+)/g;
  return isThai.test(value);
}

function encodeURIThaiObject(obj) {
  if (typeof obj !== "object" || Array.isArray(obj)) {
    return;
  }

  Object.keys(obj).forEach(function (key) {
    if (typeof obj[key] === "string" && containThai(obj[key])) {
      obj[key] = encodeURIComponent(obj[key]);
    } else if (Array.isArray(obj[key])) {
      obj[key].map((x) => {
        return encodeURIThaiObject(x);
      });
    }
  });
  return obj;
}

export function encodeThai(obj) {
  obj = JSON.parse(JSON.stringify(obj));
  obj = encodeURIThaiObject(obj);
  return obj;
}

export function after(times, func) {
  return function () {
    if (--times < 1) {
      return func.apply(this, arguments);
    }
  };
}

export function setLikeProperty(PropertyID, like) {
  var favProp = getCookie("favoriteProperty");
  if (like) {
    if (!favProp.split(",").includes(PropertyID)) {
      setCookie(
        "favoriteProperty",
        favProp
          .split(",")
          .concat(PropertyID)
          .filter((x) => x)
          .join(","),
        30
      );
    }
  } else {
    if (favProp) {
      setCookie(
        "favoriteProperty",
        favProp
          .split(",")
          .filter((e) => e != PropertyID)
          .join(","),
        30
      );
    }
  }
}

export const getCookieData = (targetList) => {
  if (targetList.length === 0) return Promise.resolve({ Items: [] });
  return postApiDataAsync({
    urlPath: "/GetProperties",
    objRequest: {
      filter: {
        PageSize: Config.FavMaxPropertyReturnCount,
        CurrentPageIndex: 1,
        PropertyIds: targetList,
      },
    },
  });
};

export const commonSearchDataChange = (
  dispatch,
  payload,
  searchFilter,
  searchDataChange,
  OnsearchListChange
) => {
  const field = payload.field;

  if (field === "province") {
    const list = searchFilter[field].option.find((x) => x.value == payload.value);
    OnsearchListChange({ field: "district", value: list?.child || [] });
    OnsearchListChange({ field: "subDistrict", value: [] });
  } else if (field === "district") {
    const list = searchFilter[field].option.find((x) => x.value == payload.value);

    OnsearchListChange({ field: "subDistrict", value: list?.child || [] });
  }
  dispatch(searchDataChange(payload));
};

export function timeInRangeList(rangeList, time = new Date()) {
  var result = null;
  rangeList.some((range) => {
    return time >= range[0] && time <= range[1] ? ((result = range), true) : false;
  });
  return result;
}

export function dmyHmsToDateObj(str) {
  var dateTimeParts = str.split("T");
  var dateParts = dateTimeParts[0].split("-");
  var timeParts = dateTimeParts[1].split(":");

  return new Date(
    +dateParts[0],
    +dateParts[1] - 1,
    +dateParts[2],
    +timeParts[0],
    +timeParts[1],
    +timeParts[2]
  );
}
export function getDateTimeFormat(date, hasTime = true) {
  var str = date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  if (hasTime) {
    str +=
      " เวลา " +
      date.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit",
      }) +
      " น.";
  }

  return str;
}

// Global favorite func
window.addToFavoriteProperty = function (id) {
  // Retrieve existing 'favoriteProperty' cookie value
  const existingFavorites = getCookie("favoriteProperty") || "";

  // Split the existing favorites by commas
  const currentFavorites = existingFavorites.split(",");

  // Add the new ID to the existing favorites
  const updatedFavorites = [...currentFavorites, id];

  // Deduplicate the array by converting it to a Set and then back to an array
  const uniqueFavorites = Array.from(new Set(updatedFavorites));

  // Join the unique ids into a comma-separated string
  const updatedFavoritesString = uniqueFavorites.join(",");

  // Set the 'favoriteProperty' cookie with the updated value
  setCookie("favoriteProperty", updatedFavoritesString, 30); // Change 30 to the desired expiration time in days
};

window.removeFromFavoriteProperty = function (id) {
  // Retrieve existing 'favoriteProperty' cookie value
  const existingFavorites = getCookie("favoriteProperty") || "";

  // Split the existing favorites by commas
  const currentFavorites = existingFavorites.split(",");

  // Remove the specified ID from the existing favorites
  const updatedFavorites = currentFavorites.filter((favorite) => favorite !== id);

  // Join the remaining favorites into a comma-separated string
  const updatedFavoritesString = updatedFavorites.join(",");

  // Set the 'favoriteProperty' cookie with the updated value
  setCookie("favoriteProperty", updatedFavoritesString, 30); // Change 30 to the desired expiration time in days
};

export function groupDataBy(array, propertyName) {
  if (array) {
    return array.reduce((acc, obj) => {
      const key = obj[propertyName];
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
  }else{
    return [];
  }
}

export function addQueryString(queryParams) {
  const queryString = new URLSearchParams(queryParams).toString();
  return `?${queryString}`;
}

export function getQueryStringParameter(param) {
  // Get the full query string from the URL
  const queryString = window.location.search;

  // Create a URLSearchParams object
  const urlParams = new URLSearchParams(queryString);

  // Get the value of the specified parameter
  return urlParams.get(param);
}